module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v(_vm._s(_vm.gridTitle))]), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "flat": "",
      "color": "white"
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('link', {
          attrs: {
            "rel": "icon",
            "href": "<%= BASE_URL %>test.pdf"
          }
        })]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Refresh")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticClass: "mb-2",
          attrs: {
            "color": "primary",
            "dark": ""
          },
          on: {
            "click": function($event) {
              return _vm.$emit('refreshData')
            }
          }
        }, on), [_c('v-icon', [_vm._v("refresh")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Refresh")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticClass: "mb-2",
          attrs: {
            "color": "primary",
            "dark": ""
          },
          on: {
            "click": _vm.newItem
          }
        }, on), [_c('v-icon', [_vm._v("add")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Add Note/Task")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticClass: "mb-2",
          attrs: {
            "disabled": _vm.selectedGridItems <= 0,
            "color": "primary",
            "dark": ""
          },
          on: {
            "click": function($event) {
              _vm.selectedGridItems == 0 ? _vm.printDialog = false : _vm.printDialog = true
            }
          }
        }, on), [_c('v-icon', [_vm._v("print")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Print Note/Task(s)")])])], 1), _vm._v(" "), _c('grid', {
    attrs: {
      "selectable": true,
      "actions": _vm.gridActions,
      "editable": true,
      "completeable": true,
      "numColumns": 9
    },
    on: {
      "toggleAll": function($event) {
        return _vm.$emit('toggleAll')
      },
      "editItem": _vm.editItem,
      "completeItem": _vm.completeTask
    },
    model: {
      value: (_vm.grid),
      callback: function($$v) {
        _vm.grid = $$v
      },
      expression: "grid"
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "500px"
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        _vm.printDialog = false
      }
    },
    model: {
      value: (_vm.printDialog),
      callback: function($$v) {
        _vm.printDialog = $$v
      },
      expression: "printDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Logo Print Option")])]), _vm._v(" "), _c('v-card-text', [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedGridItems == 1),
      expression: "selectedGridItems == 1"
    }],
    attrs: {
      "xs12": ""
    }
  }, [_vm._v("\n                            Would you like to print with the company logo for 1 note?\n                        ")]), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedGridItems > 1),
      expression: "selectedGridItems > 1"
    }],
    attrs: {
      "xs12": ""
    }
  }, [_vm._v("\n                            Would you like to print with the company logo for " + _vm._s(_vm.selectedGridItems) + " notes?\n                        ")])], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.printDialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.print(false)
      }
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.print(true)
      }
    }
  }, [_vm._v("Yes")])], 1)], 1)], 1), _vm._v(" "), (_vm.noteTaskDialog) ? _c('note-task', {
    attrs: {
      "showMe": _vm.noteTaskDialog,
      "hearingDetails": _vm.hearingDetails,
      "noteID": this.editedItem
    },
    on: {
      "closed": _vm.closeDialog
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-ef06a532", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ef06a532"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/src/portalhome/docketing/pages/hearingdetails/notetask/notetasklist.vue.html
// module id = 594
// module chunks = 0